<template>
  <div>
    <i
      class="fa fa-spin fa-circle-o-notch"
      v-if="loading"
    />
    <div
      class="form-group"
      v-else
    >
      <p class="form-text">
        <span v-if="integration.id">
          {{ __('Integração configurada. Caso queira alterar') }}
          <a
            href="#"
            @click.prevent="updating = ! updating"
          >{{ __('clique aqui') }}</a>.</span><span v-else>{{ __('Para configurar a integração com a Central Telefônica adicione os dados nos campos abaixo e clique em salvar') }}.</span>
      </p>
      <form
        @submit.prevent="save()"
        v-if="! integration.id || updating"
      >
        <label class="lg">{{ __('URL da Central') }}</label>
        <p>
          <input
            class="form-control"
            type="url"
            v-model="config.options.host"
            :readonly="locked"
            required="required"
          >
        </p>
        <div class="row">
          <div class="col-7">
            <label class="lg">Token</label>
            <p>
              <input
                class="form-control"
                type="text"
                v-model="config.token"
                :placeholder="tokenPlaceholder"
                :readonly="locked"
              >
            </p>
          </div>
          <div class="col-5">
            <label class="lg">{{ __('Ramal de Origem (Padrão)') }}</label>
            <p>
              <input
                class="form-control"
                type="text"
                v-model="config.options.caller"
                :readonly="locked"
                required="required"
              >
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-right">
            <p>
              <button
                class="btn btn-sm btn-box mr-1"
                type="button"
                @click.prevent="remove()"
                v-if="integration.id"
              >
                {{ __('Excluir') }}
              </button>
              <button
                class="btn btn-sm btn-box"
                type="submit"
                :disabled="disabled || locked"
              >
                {{ __('Salvar') }}
              </button>
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Integrations from '../../mixins/integrations';

export default {
  mixins: [Integrations],

  data () {
    return {
      config: {
        options: {
          host: '',
          caller: '',
          decrypt: true,
          replace_user_field: {
            caller: 'caller_id',
          },
        },
      },
      integration: {
        name: 'tel',
      },
    };
  },
};
</script>
